import {
    Actions,
    State,
    initialState,
    DOWNLOAD_FULL_INSPECTION,
    DOWNLOAD_FULL_INSPECTION_SUCCESS,
    DOWNLOAD_FULL_INSPECTION_ERROR,
    RESET_DOWNLOAD_FULL_INSPECTION
} from "../../types/inspection/download-full-inspection";


const reducers = (
    state = initialState,
    action: Actions
): State => {
    switch (action.type) {

        case DOWNLOAD_FULL_INSPECTION:
            return {
                ...state,
                states: {
                    loading: true,
                    success: false,
                    error: false,
                },
            }
        case DOWNLOAD_FULL_INSPECTION_SUCCESS:
            return {
                ...state,
                states: {
                    loading: false,
                    success: true,
                    error: false,
                },
            }
        case DOWNLOAD_FULL_INSPECTION_ERROR:
            return {
                ...state,
                states: {
                    loading: false,
                    success: false,
                    error: action.payload,
                },
            }
        case RESET_DOWNLOAD_FULL_INSPECTION:
            return {
                ...state,
                states: {
                    loading: false,
                    success: false,
                    error: false,
                },
            }
        default:
            return state;
    }
}

export default reducers;